var _path, _g, _path2, _path3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestdb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_897)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_74_897",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 20,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000976562 0H18.983V22.922H-0.000976562V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_74_897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.319 11.442C4.319 7.46902 7.561 4.27002 11.585 4.27002C13.038 4.27002 14.378 4.67202 15.495 5.41002L18.624 2.35602C16.5975 0.822486 14.1244 -0.00503516 11.583 2.30514e-05C5.179 2.30514e-05 0 5.11402 0 11.442C0 17.774 5.18 22.887 11.586 22.887V18.617C7.562 18.617 4.319 15.418 4.319 11.442Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8459 11.442H23.1659C23.1659 8.42596 21.9759 5.66796 20.0379 3.60596L16.9829 6.62596C18.178 7.94572 18.8417 9.6615 18.8459 11.442Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_74_897",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 10,
    width: 20,
    height: 13
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98291 10.934H26.3349V22.922H7.98291V10.934Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_74_897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1229 11.813H8.75293L20.0029 22.923L26.3349 22.887L15.1229 11.813Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_74_897",
    x1: 26.0744,
    y1: 22.9591,
    x2: 5.61491,
    y2: 1.9488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_74_897",
    x1: 4.65558,
    y1: 1.35699,
    x2: 25.8404,
    y2: 22.4654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_74_897",
    x1: 25.1431,
    y1: 22.4375,
    x2: 3.5463,
    y2: 1.54128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.335,
    height: 22.922
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestdb);
export default __webpack_public_path__ + "static/media/questdb.c37a2b3650641dae8a36297df0facff8.svg";
export { ForwardRef as ReactComponent };